module.exports = __webpack_public_path__ + "img/set4.edd6ba68.png";